import api from '@/api/api.js'
import { StorageService } from '@/helpers/storage'

const AuthService = {
  async isApiKeyValid() {
    let apiKeyValid = false
    await api
      .get('/organizations')
      .then(() => {
        apiKeyValid = true
      })
      .catch(() => {
        apiKeyValid = false
      })
    return apiKeyValid
  },
  setUseSSO(useSSO) {
    StorageService.saveUseSSO(useSSO)
  },
  isUsingSSO() {
    if (
      StorageService.getUseSSO() != true &&
      StorageService.getUseSSO() != false
    ) {
      StorageService.saveUseSSO(true)
    }
    return StorageService.getUseSSO()
  },
  notUsingSSO() {
    return !this.isUsingSSO()
  }
}

export { AuthService }
